import BaseViewIoTCloud from './BaseViewIoTCloud';
import './BaseViewIoTCloud.scss';

export default BaseViewIoTCloud;
